import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { IconLibrary } from 'libs/gb-dashboard/shared/ui/src/lib/gb-icon/gb-icon-library.models'
import iconData from './icons.json'

@Component({
  selector: 'gb-icon-picker',
  templateUrl: './gb-icon-picker.component.html',
  styleUrls: ['./gb-icon-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbIconPickerComponent {
  @Input() displayIcon: string | null = ''
  @Output() selectIcon = new EventEmitter<string>()

  Iconlibrary = IconLibrary

  icons = iconData.slice()

  searchValue = ''

  showIconSelect = false

  toggleShowIconSelect() {
    this.showIconSelect = !this.showIconSelect
  }

  onClickIcon(iconName: string) {
    this.selectIcon.emit(iconName)
    this.toggleShowIconSelect()
  }
}
